import { createSlice } from "@reduxjs/toolkit";
import { Payout } from "./services/payOutService";

interface PayoutState {
    payouts: Payout[];
    loading: boolean;
    error: any;
    rowsPerPage: number;
}

const initialState: PayoutState = {
    payouts: [],
    loading: false,
    error: null,
    rowsPerPage: 10,
};

export const payoutSlice = createSlice({
    name: "payouts",
    initialState,
    reducers: {
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        clearRowsPerPage(state) {
            state.rowsPerPage = 10;
        }
    },
});

export const { setRowsPerPage, clearRowsPerPage } = payoutSlice.actions;

export default payoutSlice.reducer;
